var map = {
	"./Download": [
		8742,
		742
	],
	"./Download/": [
		8742,
		742
	],
	"./Download/index": [
		8742,
		742
	],
	"./Download/index.tsx": [
		8742,
		742
	],
	"./Home": [
		91,
		164,
		91
	],
	"./Home/": [
		91,
		164,
		91
	],
	"./Home/index": [
		91,
		164,
		91
	],
	"./Home/index.tsx": [
		91,
		164,
		91
	],
	"./Privacy": [
		9062,
		62
	],
	"./Privacy/": [
		9062,
		62
	],
	"./Privacy/index": [
		9062,
		62
	],
	"./Privacy/index.tsx": [
		9062,
		62
	],
	"./Recados": [
		5281,
		281
	],
	"./Recados/": [
		5281,
		281
	],
	"./Recados/index": [
		5281,
		281
	],
	"./Recados/index.tsx": [
		5281,
		281
	],
	"./Terms": [
		59,
		59
	],
	"./Terms/": [
		59,
		59
	],
	"./Terms/index": [
		59,
		59
	],
	"./Terms/index.tsx": [
		59,
		59
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;